import React, { useState, useEffect } from 'react';

import { makeStyles } from "@material-ui/core/styles";
import TableSpc from "components/TableSpc/TableSpc.js";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';


import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import GetAppIcon from "@material-ui/icons/GetApp";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";


import api from "assets/services/api";


import ModalUpdateSpcOperator from 'components/ModalUpdateSpcOperator/ModalUpdateSpcOperator';
import ModalDesaprovedSpcOperator from "components/ModalDesaprovedSpcOperator/ModalDesaprovedSpcOperator";

const styles = {
    imageTabulation: {
        width: 90,
        height: 90,
        borderRadius: 90,
        marginRight: 20 / 2
    }
}
const styles4 = {
    tp: {
        marginTop: "10px",
    },
    upload: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#000000",
        backgroundColor: "transparent",
        marginTop: "10px",
        border: "none",
    },
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }
};

const useStyles2 = makeStyles(styles2);
const useStyles4 = makeStyles(styles4);

function ModalViewSpcOperator(props) {

    const classes2 = useStyles2();
    const classes4 = useStyles4();

    const [index, setIndex] = useState({ id: 0 });
    const id_client = props.props.id
    const social_reason = props.props.social_reason
    const [modalDesaprovedSpcOperator, setModalDesaprovedSpcOperator] = useState(false);
    const [modalUpdtSpcOperator, setModalUpdtSpcOperator] = useState(false);
    const [spc, setSpc] = useState([])



    useEffect(() => {
        loadSpc(props)
    }, [])

    useEffect(() => {
        props.getAllClients()
    }, [spc])



    async function loadSpc(props) {
        const spc = await api.get('/client/spc/' + id_client)
        setSpc(spc.data)
    }

    async function downloadSpc(id_spc) {
        await api
            .get("client/spc/download/" + id_client + '/' + id_spc, {
                responseType: "blob",
            })
            .then(function (response) {
                let blob = new Blob([response.data], {
                    responseType: "arraybuffer",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/pdf",
                    },
                });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "Consulta SPC ->" + social_reason + ".pdf"
                link.click();
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    function callModalDesaprovedSpc(index) {
        setIndex(index)
        setModalDesaprovedSpcOperator(true)
    }

    function callModalUpdateSpc(index) {
        setIndex(index)
        setModalUpdtSpcOperator(true)
    }



    function getSpc() {
        let teste = [];
        if (spc) {
            for (let i = 0; i < spc.length; i++) {
                teste[i] = [];
                teste[i].push(props.props.social_reason)
                teste[i].push(
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Group as={Col} controlId="formGridBox">
                                <Tooltip
                                    id="tooltip-top"
                                    title={"Download SPC"}
                                    placement="top"
                                    classes={{ tooltip: classes2.tooltip }}
                                >
                                    <IconButton
                                        aria-label="Done"
                                        className={classes2.tableActionButton}
                                        onClick={() => downloadSpc(spc[i].id)}
                                    >
                                        <GetAppIcon
                                            className={
                                                classes2.tableActionButtonIconDownload +
                                                " " +
                                                classes2.edit4 +
                                                " " +
                                                classes4.tp
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                            </Form.Group>
                        </Form.Group>
                    </Form.Row>
                )
                teste[i].push(
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox"><Tooltip
                            id="tooltip-top"
                            title="Aprovar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Edit"
                                className={classes2.tableActionButton}
                                onClick={() => callModalUpdateSpc(spc[i])}

                            >
                                <DoneIcon
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.edit8
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox"><Tooltip
                            id="tooltip-top"
                            title="Desaprovar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Edit"
                                className={classes2.tableActionButton}
                                onClick={() => callModalDesaprovedSpc(spc[i])}

                            >
                                <ClearIcon
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.edit7
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                        </Form.Group>
                    </Form.Row>
                )
                teste[i].push(
                    <CardIcon>
                        <Icon title={spc[i].validated_operator ? "Validado" : "Não validado"}>{spc[i].validated_operator ? "done" : "clear"}</Icon>
                    </CardIcon>
                )

            }
            return teste;
        }
        return teste;
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Consultas SPC de {props.props.social_reason}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <TableSpc
                    tableHeaderColor="primary"
                    tableHead={["Client", "Baixar SPC", "Validar", "Status"]}
                    tableData={getSpc()}
                />
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
            <ModalDesaprovedSpcOperator key={String("DesaprovedSpcOpe_" + index.id)} props={index} show={modalDesaprovedSpcOperator} onHide={() => setModalDesaprovedSpcOperator(false)} handleShowContact={() => { }} loadSpc={() => loadSpc()} />
            <ModalUpdateSpcOperator key={String("UpdContSpcOpe_" + index.id)} props={index} show={modalUpdtSpcOperator} onHide={() => setModalUpdtSpcOperator(false)} handleShowContacts={() => { }} loadSpc={() => loadSpc()} />
        </Modal>
    );
}

export default ModalViewSpcOperator;